import React, { useEffect, useRef, useState } from "react";
import { Skeleton } from "antd";

const useInViewportOnce = (rootMargin = "1000px") => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin, threshold: 0.01 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [inView, rootMargin]);
  return [ref, inView];
};

const LazyMount = ({ placeholder, children }) => {
  const [ref, inView] = useInViewportOnce();
  const [showChildren, setShowChildren] = useState(false);
  useEffect(() => {
    if (!inView) return;
    // yield one frame so the placeholder/skeleton can actually paint first
    const id = requestAnimationFrame(() => setShowChildren(true));
    return () => cancelAnimationFrame(id);
  }, [inView]);
  return (
    <div ref={ref} className="min-w-0">
      {showChildren
        ? children
        : (placeholder ?? (
            <Skeleton active paragraph={{ rows: 3 }} style={{ padding: 12 }} />
          ))}
    </div>
  );
};

export default LazyMount;
